import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { ActivityPeriod } from '@services/activity.service';
import { PERIOD_OPTIONS } from './auditFilterOptions';

interface PeriodSelectProps {
  value: ActivityPeriod;
  onChange: (period: ActivityPeriod) => void;
}

const PeriodSelect: React.FC<PeriodSelectProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
  <Select value={value} onValueChange={(next) => onChange(next as ActivityPeriod)}>
    <SelectTrigger aria-label={t('audit.period')} className="w-auto min-w-[5rem] gap-2">
      <SelectValue />
    </SelectTrigger>
    {/* Portalled to <body>, so it carries the island class or renders unstyled. */}
    <SelectContent className="revy-ui">
      {PERIOD_OPTIONS.map((period) => (
        <SelectItem key={period} value={period} className="revy-figure">
          {period}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
  );
};

export default PeriodSelect;
